import EdoCapitalCall from './EdoCapitalCall';

export default EdoCapitalCall;
